// extracted by mini-css-extract-plugin
export default {"Buttons":"IFDialog_Buttons__cXnYl","Title":"IFDialog_Title__jctW+","TitleText":"IFDialog_TitleText__N41oK","CustomMargin":"IFDialog_CustomMargin__bFiA7"};